.biel-search-input-container {
  display: flex;
  align-items: center;
}

.biel-search-input-container svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.search-input {
  width: 100%;
  border: none;
  background-color: transparent;
  font-size: 16px;
  outline: none;
  color: var(--biel-input-color);
  padding: 8px 0px;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}